import { type Step } from './FunnelEmbed.schema';

export const tooltipContentMap: Record<Step, string | undefined> = {
  postalCode: 'Mit der Postleitzahl wird geprüft, ob unser Service in deiner Region verfügbar ist.',
  houseType: 'Dein Haustyp bestimmt, welche Solaranlage für deinen individuellen Verbrauch am effektivsten ist.',
  roofMaterial: 'Die Art des Dachmaterials wird benötigt, um die Dachkonstruktion für die SolarModule zu bestimmen.',
  name: 'Der Name wird benötigt, damit eine persönliche Beratung stattfinden kann.',
  address: 'Die Adresse wird für den Vor-Ort-Termin mit einem SolarProfi benötigt.',
  phoneNumber:
    'Die Telefonnummer wird benötigt, um ein persönliches Beratungsgespräch mit einem Experten zu ermöglichen.',
  email: 'Die E-Mail wird benötigt, um dich zu erreichen, dir Dokumente zu senden und weitere Schritte zu planen.',
  unsupportedRegion: undefined,
  unsupportedRoofMaterial: undefined,
};

export const titleMap: Record<Step, string> = {
  postalCode: 'Wo soll Deine SolarAnlage installiert werden?',
  houseType: 'Um welchen Haustyp handelt es sich?',
  roofMaterial: 'Aus welchem Material besteht dein Dach?',
  name: 'Wie lautet dein Name?',
  address: 'Wie lautet deine Adresse?',
  phoneNumber: 'Unter welcher Nummer können wir dich erreichen?',
  email: 'Wie lautet deine E-Mail-Adresse?',
  unsupportedRegion: 'Sorry, in deiner Region ist aktuell leider kein Fachpartner verfügbar.',
  unsupportedRoofMaterial:
    'Schade, leider ist die Installation unserer SolarAnlage mit deinem Dachmaterial momentan nicht möglich.',
};

export const legalTextSnippets = [
  'Wir verarbeiten deine Daten ausschließlich zur Erstellung, Versand und Abstimmung deines Angebotes, sowie zur Kommunikation hierzu mit dir. Weitere Informationen findest du in unseren ',
  'Datenschutzhinweisen',
  '.',
];

export const legalText = legalTextSnippets.join();

export const SERVER_ERROR_MESSAGE =
  'Hoppla, es gibt wohl eine technische Störung. Versuche es gerne etwas später noch einmal.';

export const CONNECTION_ERROR_MESSAGE =
  'Hoppla, der Server scheint nicht erreichbar zu sein. Bitte überprüfe deine Internetverbindung oder versuche es einfach später noch einmal.';
